var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConciergeAvatar = function SvgConciergeAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "concierge-avatar_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".concierge-avatar_svg__st2{fill:#002140}.concierge-avatar_svg__st3{fill:#fffaf0}.concierge-avatar_svg__st4{fill:none;stroke:#002140;stroke-linecap:round;stroke-linejoin:round}.concierge-avatar_svg__st5{fill:#fed607}")), /*#__PURE__*/React.createElement("path", {
    d: "M40 0c22.1 0 40 17.9 40 40S62.1 80 40 80 0 62.1 0 40 17.9 0 40 0z",
    style: {
      fill: "#085239"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 59.5h56.5L40 9.8 11.9 59.5z",
    style: {
      fill: "#03d47c"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 53.8s2.3 3.1 7.1 3c4.8-.1 6.8-3.2 6.8-3.2l-13.9.2z",
    className: "concierge-avatar_svg__st2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 29.4s.3 8.7 11.5 8.7 10-9.3 10-9.3-4.5-4-10.6-4.2c-6-.1-10.9 4.8-10.9 4.8zM49.5 49.2H31.6l1.3 4h15.4l1.2-4z",
    className: "concierge-avatar_svg__st3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 9.6 12 59.4h56.6L40 9.6z",
    className: "concierge-avatar_svg__st4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 29s-11.2-9.8-21.5.1",
    className: "concierge-avatar_svg__st4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7 29.8s0 8 11.2 8 10.2-9.4 10.2-9.4",
    className: "concierge-avatar_svg__st4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m41 31.6 3-2.6c-.8-1.5-2.3-2.5-4.1-2.5-2.5 0-4.6 2.1-4.6 4.6 0 2.5 2.1 4.6 4.6 4.6 2.2 0 4-1.5 4.4-3.5l-3.3-.6z",
    className: "concierge-avatar_svg__st2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 45.3h40M33.5 21.7h13.4M32.4 45.2l2.6-7.5M48.2 45.2 45 37M49.4 49.2H31.3s.4 7.4 9 7.4c8.5.1 9.1-7.4 9.1-7.4zM40.3 59.2V57M40.3 49.2v-3.5M33.3 53.7h13.9M37.1 53.5v-4M44.2 53.5v-4",
    className: "concierge-avatar_svg__st4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1 28s-1.3 5.5-5.6 5.5c0 0 5 1.4 5.4 5.4 0 0 1.5-4.8 5.8-5.2-.1 0-5.3-1.2-5.6-5.7z",
    className: "concierge-avatar_svg__st5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9 33.6c-4.1 1.1-4.9 1.9-6 6-1.1-4.1-1.9-4.9-6-6 4.1-1.1 4.9-1.9 6-6 1.1 4.1 2 4.9 6 6z",
    className: "concierge-avatar_svg__st4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 28.2s-2.2 5.2-5.6 5.5c0 0 4.9 2.2 5.4 5.4 0 0 2-5 5.8-5.5-.1-.1-5.3-.9-5.6-5.4z",
    className: "concierge-avatar_svg__st5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21 33.6c-4.1 1.1-4.9 1.9-6 6-1.1-4.1-1.9-4.9-6-6 4.1-1.1 4.9-1.9 6-6 1.1 4.1 1.9 4.9 6 6z",
    className: "concierge-avatar_svg__st4"
  })));
};
export default SvgConciergeAvatar;